// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiNftLinkMediaPreview } from '../models/ApiNftLinkMediaPreview';
import { HttpFile } from '../http/http';

export class ApiNftLinkData {
    'canonical_id': string;
    'platform': string;
    'chain': string | null;
    'contract': string | null;
    'token': string | null;
    'name': string | null;
    'description': string | null;
    'media_uri': string | null;
    'last_error_message': string | null;
    'price': string | null;
    'price_currency': string | null;
    'last_successfully_updated': number | null;
    'failed_since': number | null;
    'media_preview': ApiNftLinkMediaPreview | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "canonical_id",
            "baseName": "canonical_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "platform",
            "baseName": "platform",
            "type": "string",
            "format": ""
        },
        {
            "name": "chain",
            "baseName": "chain",
            "type": "string",
            "format": ""
        },
        {
            "name": "contract",
            "baseName": "contract",
            "type": "string",
            "format": ""
        },
        {
            "name": "token",
            "baseName": "token",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "media_uri",
            "baseName": "media_uri",
            "type": "string",
            "format": ""
        },
        {
            "name": "last_error_message",
            "baseName": "last_error_message",
            "type": "string",
            "format": ""
        },
        {
            "name": "price",
            "baseName": "price",
            "type": "string",
            "format": ""
        },
        {
            "name": "price_currency",
            "baseName": "price_currency",
            "type": "string",
            "format": ""
        },
        {
            "name": "last_successfully_updated",
            "baseName": "last_successfully_updated",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "failed_since",
            "baseName": "failed_since",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "media_preview",
            "baseName": "media_preview",
            "type": "ApiNftLinkMediaPreview",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiNftLinkData.attributeTypeMap;
    }

    public constructor() {
    }
}
